export default __webpack_public_path__ + "static/media/footer-program-img-3.d3fddafb.png";